import { apiProvider } from "./utilities/provider";

export type AdminWhoAmIResponse = {
  id: number;
  name: string;
  email: string;
  isAdmin: boolean;
};

export const adminApi = {
  async whoAmI(): Promise<AdminWhoAmIResponse> {
    const res: any = await apiProvider.getAll("admin/whoami");

    if (res?.data?.data) {
      return res.data.data;
    }

    if (res?.data) {
      return res.data;
    }

    return res;
  },
};
